import SaudeSistema from '../views/SaudeSistema/Crud'

let routes = {
  path: '/painel-admin',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/painel-admin',
      name: 'painel-admin',
      component: SaudeSistema,
      meta: {
        pageTitle: 'Painel Administrativo do Sistema',
        breadcrumb: [
          {
            text: 'Painel Administrativo',
            active: true,
            to: '/painel-admin',
          },
        ],
      },
    },
  ]
};

export default routes
